import { render, staticRenderFns } from "./DescubreV.vue?vue&type=template&id=7f60477e&scoped=true"
import script from "./DescubreV.vue?vue&type=script&lang=js"
export * from "./DescubreV.vue?vue&type=script&lang=js"
import style0 from "./DescubreV.vue?vue&type=style&index=0&id=7f60477e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f60477e",
  null
  
)

export default component.exports